;(function () {
  angular
    .module('contrast.servers')
    .controller('ServerOverviewCtrl', ServerOverviewCtrl)

  function ServerOverviewCtrl(
    $scope,
    $routeParams,
    $location,
    $translate,
    permissions,
    UserService,
    LoadFilterRouteService,
    ChartService,
    LanguagesService,
    LicenseService,
    ServerService,
    currentServerService,
    LoadFilterService,
    TIME_SERIES_SELECT,
    SERVER_EVENTS,
    SUBFILTERS,
    QUICK_FILTERS
  ) {
    'ngInject'

    var translGlobal = {
      detail_lookingGood: $translate.instant('detail_lookingGood'),
      title_progressWorking: $translate.instant('title_progressWorking')
    }

    var _getServerOptions = { buildDotNet: true },
      _deregisterCurrentServerOnChange

    angular.extend($scope, {
      serverId: $routeParams.serverId,
      vuln_breakdown_types: ChartService.getTraceBreakdownTypes(),
      attack_breakdown_types: ChartService.getAttackBreakdownTypes(),
      vulns: {
        count: 0,
        thermometer: []
      },
      attacks: {
        count: 0,
        thermometer: []
      },
      model: {},
      timeseries: TIME_SERIES_SELECT,
      reports: [],

      orgUuid: $routeParams.orgUuid,

      loadLibraryPromise: false,
      loadServerPromise: false,
      protection: {
        breakdown: {
          total: 0,
          unused: 0,
          used: 0
        }
      },
      protectEligible: false,
      sampleId: UserService.getSampleServerID(),
      linkToVulnerableLibs: ''
    })

    angular.extend($scope.model, {
      restart_protection: false,
      restart_assess: false,
      updatingDefend: false,
      updatingAssess: false,
      vuln_type: $scope.vuln_breakdown_types[0],
      attack_type: $scope.attack_breakdown_types[0],
      limit: 10,
      time: $scope.timeseries[0],
      isFreemium: UserService.isFreemiumOrganization()
    })

    angular.extend($scope, {
      changeDefend: changeDefend,
      changeAssess: changeAssess,
      vulnBreakdownSelected: vulnBreakdownSelected,
      getVulnsMessage: getVulnsMessage,
      attackBreakdownSelected: attackBreakdownSelected,
      getAttacksMessage: getAttacksMessage,
      showAllApps: showAllApps,
      timeSelected: timeSelected,
      onThermometerClick: onThermometerClick,
      goToApps: goToApps,
      goToOpenVulns: goToOpenVulns,
      isProtectionSwitchDisabled: isProtectionSwitchDisabled,
      validProtectionLicenseLanguage: validProtectionLicenseLanguage,
      isSampleServer: isSampleServer
    })

    function init() {
      $scope.loadServerPromise = false

      if (!_deregisterCurrentServerOnChange) {
        _deregisterCurrentServerOnChange = currentServerService.onChange(
          function (server) {
            $scope.server = server
          },
          _getServerOptions
        )
      }

      $scope.$on('$destroy', _destroy)

      getServer().then(function () {
        $scope.loadServerPromise = true
      })

      $scope.loadLibraryPromise = false
      getLibStats().then(function () {
        $scope.loadLibraryPromise = true
      })

      vulnBreakdownSelected()

      if (permissions.isRASPEnabled()) {
        $scope.attackBreakdownSelected()
        if (permissions.hasPermission('RULES_ADMIN')) {
          loadProtectionLicenseBreakdown()
        }
      }

      $scope.timeSelected()
      getRemediationPolicyViolations()
      $scope.$on(SERVER_EVENTS.UPDATE_SERVER, getServer)
      $scope.isProxyServer = LanguagesService.isProxy($scope.server.language)

      setLinkToLibs()
    }

    function _destroy() {
      if (angular.isFunction(_deregisterCurrentServerOnChange)) {
        _deregisterCurrentServerOnChange()
      }
    }

    function loadProtectionLicenseBreakdown() {
      LicenseService.getProtectionBreakdown().then(function (breakdown) {
        $scope.protection.breakdown = breakdown
      })
    }

    function changeDefend() {
      _updateProtection()
    }

    function changeAssess() {
      $scope.model.updatingAssess = true
      currentServerService
        .toggleAssess()
        .then(function () {
          $scope.model.updatingAssess = false
          if (!$scope.server.assess_sensors) {
            $scope.model.restart_assess = true
          }
          $scope.server.assess_last_update = moment()
        })
        .catch(function () {
          $scope.model.updatingAssess = false
        })
    }

    function vulnBreakdownSelected() {
      var promise = null
      // TODO: CONTRAST-18297
      // eslint-disable-next-line default-case
      switch ($scope.model.vuln_type) {
        case 'Severity':
          promise = ServerService.getVulnSeverityBreakdown($scope.serverId)
          break

        case 'Status':
          promise = ServerService.getVulnStatusBreakdown($scope.serverId)
          break

        case 'Type':
          promise = ServerService.getVulnRuleBreakdown($scope.serverId)
          break
      }

      if (promise) {
        promise.then(function (data) {
          var thermometerData = {}

          thermometerData = ChartService.buildTraceThermometerData(
            $scope.model.vuln_type,
            data
          )
          $scope.vulns.count = thermometerData.count
          $scope.vulns.thermometer = thermometerData
        })
      }
    }

    function getVulnsMessage() {
      var transl = {
        detail_vulnerabilityAnalysisPending: $translate.instant(
          'detail_vulnerabilityAnalysisPending'
        ),
        detail_serverOverview_vulnerabilityAnalysisUnavailable:
          $translate.instant(
            'detail_serverOverview_vulnerabilityAnalysisUnavailable'
          )
      }

      $scope.server.assess_disabled = false
      if ($scope.server.assess) {
        if ($scope.vulns.thermometer.count == 0) {
          if ($scope.server.assess_sensors) {
            return translGlobal.detail_lookingGood
          } else {
            $scope.server.assess_disabled = true
            return transl.detail_vulnerabilityAnalysisPending
          }
        } else if ($scope.loadServerPromise) {
          return transl.detail_serverOverview_vulnerabilityAnalysisUnavailable
        } else {
          return translGlobal.title_progressWorking
        }
      }
      return ''
    }

    function attackBreakdownSelected() {
      var promise = null
      // TODO: CONTRAST-18297
      // eslint-disable-next-line default-case
      switch ($scope.model.attack_type) {
        case 'Status':
          promise = ServerService.getAttackStatusBreakdown($scope.serverId)
          break

        case 'Type':
          promise = ServerService.getAttackTypeBreakdown($scope.serverId)
          break
      }

      if (promise) {
        promise.then(function (data) {
          var thermometerData = {}

          thermometerData = ChartService.buildAttackThermometerData(
            $scope.model.attack_type,
            data
          )
          $scope.attacks.count = thermometerData.count
          $scope.attacks.thermometer = thermometerData
        })
      }
    }

    function getAttacksMessage() {
      var transl = {
        detail_serverOverview_attackAnalysisPending: $translate.instant(
          'detail_serverOverview_attackAnalysisPending'
        ),
        detail_serverOverview_attackAnalysisUnavailable: $translate.instant(
          'detail_serverOverview_attackAnalysisUnavailable'
        )
      }

      $scope.server.protection_disabled = false
      if ($scope.server.defend) {
        if ($scope.attacks.thermometer.count == 0) {
          if ($scope.server.defend_sensors) {
            return translGlobal.detail_lookingGood
          } else {
            $scope.server.protection_disabled = true
            return transl.detail_serverOverview_attackAnalysisPending
          }
        }
      } else if ($scope.loadServerPromise) {
        return transl.detail_serverOverview_attackAnalysisUnavailable
      } else {
        return translGlobal.title_progressWorking
      }
      return ''
    }

    function showAllApps() {
      $scope.model.limit = 'Infinity'
    }

    function timeSelected() {
      var interval = ChartService.getIntervals().find(function (value) {
        return value.description == $scope.model.time.text
      }).value

      ServerService.getServerActivityByInterval($scope.serverId, interval).then(
        function (data) {
          $scope.reports = ChartService.buildServerActivityTrendData(
            data,
            interval
          )
        }
      )
    }

    function onThermometerClick(record) {
      if (record.link) {
        if (record.type == 'vuln') {
          var filters = {}

          switch (record.breakdown) {
            case 'Severity':
              filters[SUBFILTERS.VULNS.ENUM.SEVERITY] = [
                record.keycode.toUpperCase()
              ]
              filters[SUBFILTERS.VULNS.ENUM.STATUS] = [
                'Reported',
                'Suspicious',
                'Confirmed'
              ]
              LoadFilterRouteService.goToServerVulnerabilities(
                filters,
                $scope.serverId
              )
              break

            case 'Status':
              filters[SUBFILTERS.VULNS.ENUM.STATUS] = [record.keycode]
              LoadFilterRouteService.goToServerVulnerabilities(
                filters,
                $scope.serverId
              )
              break

            case 'Type':
              filters[SUBFILTERS.VULNS.ENUM.VULNTYPE] = [record.keycode]
              filters[SUBFILTERS.VULNS.ENUM.STATUS] = [
                'Reported',
                'Suspicious',
                'Confirmed'
              ]
              LoadFilterRouteService.goToServerVulnerabilities(
                filters,
                $scope.serverId
              )
              break

            default:
              break
          }
        } else if (record.type == 'attack') {
          if (!$scope.model.isFreemium) {
            if (record.breakdown === 'Status') {
              LoadFilterService.setAttackStatus(record.name.toUpperCase())
            } else {
              LoadFilterService.setAttackQuickFilter(
                QUICK_FILTERS.ATTACK_EVENTS[record.name.toUpperCase()].KEY
              )
            }
            $location.path(
              UserService.buildUrl('/servers/' + $scope.serverId + '/attacks')
            )
          } else {
            $location.path(UserService.buildUrl('/attacks/attacks'))
          }
        }
      }
    }

    function goToApps() {
      LoadFilterRouteService.goToAppsWithServers([$scope.server.server_id])
    }

    function goToOpenVulns() {
      var filters = {}
      filters[SUBFILTERS.VULNS.ENUM.STATUS] = [
        'Reported',
        'Suspicious',
        'Confirmed'
      ]

      LoadFilterRouteService.goToServerVulnerabilities(filters, $scope.serverId)
    }

    function getRemediationPolicyViolations() {
      ServerService.getRemediationPolicyViolations($scope.serverId).then(
        function (data) {
          $scope.violations = data.traces
        }
      )
    }

    function getServer() {
      return currentServerService
        .get(true, _getServerOptions)
        .then(function (server) {
          $scope.server = server
          return server
        })
        .then(ServerService.isServerProtectEligible)
        .then(function (eligible) {
          $scope.protectEligible = eligible
        })
        .then(calculateTimes)
    }

    function getLibStats() {
      return ServerService.getLibStats($scope.serverId).then(function (data) {
        $scope.model.libs = { total: data.total, vulnerables: data.vulnerable }
      })
    }

    function calculateTimes() {
      var now = moment()
      var lastStartup = moment($scope.server.last_startup)
      var lastActivity = moment($scope.server.last_activity)
      $scope.model.lastStartup = now.diff(lastStartup, 'seconds')
      $scope.model.lastActivity = now.diff(lastActivity, 'seconds')
    }

    function isProtectionSwitchDisabled() {
      return $scope.model.updatingDefend || !$scope.protectEligible
    }

    function validProtectionLicenseLanguage() {
      return ServerService.isServerProtectEligible($scope.server, true)
    }

    function _updateProtection() {
      $scope.model.updatingDefend = true
      currentServerService
        .toggleDefend()
        .then(loadProtectionLicenseBreakdown)
        .then(function () {
          $scope.model.updatingDefend = false
          if (!$scope.server.defend_sensors) {
            $scope.model.restart_protection = true
          }
          $scope.server.defense_last_update = moment()
        })
        .catch(function () {
          $scope.server.defend = !$scope.server.defend
          $scope.model.updatingDefend = false
        })
    }

    function isSampleServer() {
      return $scope.sampleId == $scope.serverId
    }

    function setLinkToLibs() {
      $scope.linkToVulnerableLibs =
        LoadFilterRouteService.buildURLToServerLibraries($scope.serverId)
    }

    init()
  }
})()
